module.exports = __webpack_public_path__ + "static/media/icon.f2339c24.png";